import type { TimelineViewTransform } from "../ViewTransform/transform";
import { TIMELINE_MIN_ZOOM } from "../WorldMetrics/metrics";

/** Zoom at the floor usually means a bad auto-fit, not an intentional user choice. */
const MIN_RECOVERABLE_ZOOM = TIMELINE_MIN_ZOOM * 1.05;

export function isRecoverableTimelineView(
  view: TimelineViewTransform,
): boolean {
  if (
    !Number.isFinite(view.zoom)
    || !Number.isFinite(view.panX)
    || !Number.isFinite(view.panY)
  ) {
    return false;
  }
  return view.zoom > MIN_RECOVERABLE_ZOOM;
}
